<template>
    <div class="cavity-inspection-container" id="cavity-inspection">
        <section class="container">
            <div class="row-custom reverse">
                <div class="team-col">
                    <img src="../assets/images/microscoop.jpg" id="facings-techniques-img">
                </div>
                <div class="team-col">
                    <h1>Endodontologie</h1>
                    <p>
                        Een wortelkanaalbehandeling is vaak de laatste kans om een tand of kies te redden. Deze behandeling biedt in veel gevallen een slagingskans van 85% tot 95%, afhankelijk van de situatie. Tijdens de behandeling verwijderen wij het geïnfecteerde weefsel, reinigen het wortelkanaal grondig en dichten het zorgvuldig af. Hoewel een wortelkanaalbehandeling niet altijd garantie biedt, is het vaak een effectieve manier om uw natuurlijke tand te behouden en verdere klachten te voorkomen.
                        Tijdens deze behandeling werken wij met een microscoop. Zo kunnen we heel precies werken en doen we er alles aan om uw eigen tand zo goed mogelijk te behouden.
                        Heeft u vragen over onze behandelingen of wilt u een afspraak maken? Neem gerust contact met ons op. Wij staan voor u klaar!
                    </p>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "CavityInspection",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden {
  opacity: 0;
  transform: translateY(100px);
  transition: all 1.5s;
}

.show {
  opacity: 1;
  transform: translateY(0);
}

.team-col {
    flex-basis: 48%;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.cavity-inspection-container .row-custom {
    margin-top: 1.8rem;
}
.team-col h1 {
    padding-top: 0;
    margin-top: 0;
    margin-bottom: 1.4rem;
    color: var(--blue);
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#facings-techniques-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}



@media(max-width: 991px) {
    .cavity-inspection-container .row-custom {
        margin-top: 0.8rem;
    }
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #facings-techniques-img {
        height: 200px;
    }
    .reverse {
        flex-direction: column-reverse;
    }

}
</style>